import { put } from 'saga-ts';
import { $a } from 'shared-base';

export function* onCommandSuccess(id: string) {
  try {
    if (!id) {
      return;
    }

    yield put($a('COMMANDS', 'success', id, {}));
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* onCommandError(id?: string, error?: any) {
  try {
    if (!id) {
      return;
    }

    yield put($a('COMMANDS', 'error', id, { error }));
  } catch (err) {
    console.log('err =>', err);
  }
}
